import { FC, memo } from "react";
import { motion } from "framer-motion";
import styles from "./MatchPercentage.module.scss";
import idIcon from "/svg/openCard.svg";

interface MatchPercentageProps {
  onClick?: () => void;
}

export const MatchPercentage: FC<MatchPercentageProps> = memo(({ onClick }) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <div className={styles.matchPercentageContainer}>
      <div className={styles.backgroundContainers}>
        <motion.div
          className={styles.containerOuter}
          animate={{ rotate: 360 }}
          transition={{
            duration: 20,
            repeat: Infinity,
            ease: "easeIn",
          }}
        />
        <motion.div
          className={styles.containerInner}
          animate={{ rotate: -360 }}
          transition={{
            duration: 15,
            repeat: Infinity,
            ease: "easeIn",
          }}
        />
        <motion.div
          className={styles.containerOuter}
          animate={{ rotate: -180 }}
          transition={{
            duration: 10,
            repeat: Infinity,
            ease: "easeIn",
          }}
        />
        <motion.div
          className={styles.containerInner}
          animate={{ rotate: -180 }}
          transition={{
            duration: 5,
            repeat: Infinity,
            ease: "easeIn",
          }}
        />
      </div>

      <motion.button
        className={styles.matchButton}
        whileTap={{ scale: 0.95 }}
        onClick={handleClick}
      >
        <div className={styles.iconWrapper}>
          <img className={styles.icon} src={idIcon} alt="id" />
        </div>
      </motion.button>
    </div>
  );
});
